import Card from 'components/Card'
import ExportNativeAppStatsButton from 'components/misc/ExportNativeAppStatsButton'
import NativeAppAnalyticsMisc from 'components/misc/NativeAppAnalyticsMisc'
import Restricted from 'components/Restricted'
import Page from 'components/ui/Page'

const SupplyAppAnalyticsPage = () => (
    <Page title="Supply App Analytics">
        <div className="m-auto max-w-screen-xl my-16 space-y-8">
            <h1>Supply App Analytics</h1>
            <Restricted location="admin" checkWrite={false} showMessage>
                <div className="space-y-8">
                    <Card header="Export Stats">
                        <ExportNativeAppStatsButton />
                    </Card>
                    <NativeAppAnalyticsMisc />
                </div>
            </Restricted>
        </div>
    </Page>
)

export default SupplyAppAnalyticsPage
